<div class="modal-backdrop fade show" (click)="closeModal()"></div>
<div class="modal fade show d-block" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg" role="document" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">
          {{ 'Micro-Publish Certificate' | translate }}: {{ certificateName }}
        </h5>
        <button type="button" class="close" (click)="closeModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- Loading Indicator -->
        <div *ngIf="isLoading" class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">{{ 'Loading' | translate }}...</span>
          </div>
          <p class="mt-2">{{ 'Loading publish history' | translate }}...</p>
        </div>

        <!-- Publish History Table -->
        <div *ngIf="!isLoading && publishHistory.length > 0">
          <div class="mb-3 d-flex justify-content-between align-items-center">
            <div>
              <button class="btn btn-sm btn-outline-primary mr-2" (click)="selectAll()" [disabled]="isPublishing">
                {{ 'Select All' | translate }}
              </button>
              <button class="btn btn-sm btn-outline-secondary" (click)="clearSelection()" [disabled]="isPublishing">
                {{ 'Clear Selection' | translate }}
              </button>
            </div>
            <div class="text-muted">
              {{ selectedPaths.size }} {{ 'selected' | translate }}
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-hover table-sm">
              <thead>
                <tr>
                  <th style="width: 40px;"></th>
                  <th>{{ 'Published' | translate }}</th>
                  <th>{{ 'By' | translate }}</th>
                  <th>{{ 'Publish type' | translate }}</th>
                  <th>{{ 'Status' | translate }}</th>
                  <th style="width: 40px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let entry of publishHistory"
                    [class.table-active]="isPathSelected(entry.path)"
                    style="cursor: pointer;"
                    (click)="togglePath(entry.path)">
                  <td>
                    <input type="checkbox"
                           [checked]="isPathSelected(entry.path)"
                           (click)="$event.stopPropagation(); togglePath(entry.path)"
                           [disabled]="isPublishing">
                  </td>
                  <td class="small">{{ formatDate(entry.publishDate) }}</td>
                  <td class="small">{{ getUserDisplayName(entry) }}</td>
                  <td>
                    <span class="badge" [ngClass]="getPublishTypeBadge(entry.publishType)">
                      {{ entry.publishType | uppercase }}
                    </span>
                  </td>
                  <td>
                    <span class="badge" [ngClass]="getOverwriteStatusBadge(entry.overwriteStatus.overwritten)">
                      {{ getOverwriteStatusText(entry.overwriteStatus.overwritten) | translate }}
                    </span>
                    <div *ngIf="entry.overwriteStatus.overwritten" class="small text-muted mt-1">
                      {{ 'Overwritten on' | translate }}: {{ formatDate(entry.overwriteStatus.overwrittenDate) }}
                      <br>
                      <span class="text-primary" style="cursor: pointer; text-decoration: underline;"
                            (click)="$event.stopPropagation(); toggleBackupInfo(entry.path)">
                        <i class="fa" [ngClass]="isBackupInfoExpanded(entry.path) ? 'fa-eye-slash' : 'fa-eye'"></i>
                        {{ isBackupInfoExpanded(entry.path) ? ('Hide backup' | translate) : ('Show backup' | translate) }}
                      </span>
                      <div *ngIf="isBackupInfoExpanded(entry.path)" class="mt-1">
                        {{ 'Backup' | translate }}: <code class="small">{{ entry.overwriteStatus.backupPath }}</code>
                      </div>
                    </div>
                  </td>
                  <td class="text-center">
                    <span class="btn-circle-icon btn-circle-small align-self-center btn-default"
                          [title]="entry.path"
                          (click)="$event.stopPropagation(); copyPathToClipboard(entry.path)">
                      <i class="fa-regular fa-key"></i>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination Controls -->
          <div *ngIf="totalPages > 1" class="d-flex justify-content-between align-items-center mt-3">
            <div class="text-muted small">
              {{ 'Showing' | translate }} {{ currentPage * pageSize + 1 }} - {{ Math.min((currentPage + 1) * pageSize, totalElements) }} {{ 'of' | translate }} {{ totalElements }}
            </div>
            <nav aria-label="Page navigation">
              <ul class="pagination pagination-sm mb-0">
                <li class="page-item" [class.disabled]="currentPage === 0">
                  <a class="page-link" (click)="previousPage()" [attr.aria-disabled]="currentPage === 0">
                    <i class="fa fa-chevron-left"></i>
                  </a>
                </li>
                <li *ngFor="let page of getPageNumbers()"
                    class="page-item"
                    [class.active]="page === currentPage">
                  <a class="page-link" (click)="goToPage(page)">{{ page + 1 }}</a>
                </li>
                <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
                  <a class="page-link" (click)="nextPage()" [attr.aria-disabled]="currentPage >= totalPages - 1">
                    <i class="fa fa-chevron-right"></i>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="!isLoading && publishHistory.length === 0" class="text-center py-4 text-muted">
          <p>{{ 'No publish history found for this certificate' | translate }}</p>
        </div>

        <!-- Publishing Indicator -->
        <div *ngIf="isPublishing" class="alert alert-info mt-3">
          <div class="d-flex align-items-center">
            <div class="spinner-border spinner-border-sm text-info mr-2" role="status">
              <span class="sr-only">{{ 'Publishing' | translate }}...</span>
            </div>
            <span>{{ 'Publishing' | translate }} {{ selectedPaths.size }} {{ 'paths' | translate }}...</span>
          </div>
        </div>

        <!-- Publish Result -->
        <div *ngIf="showResult && publishResult" class="mt-3">
          <div class="alert" [ngClass]="publishResult.success ? 'alert-success' : 'alert-warning'">
            <h6 class="alert-heading">
              {{ publishResult.success ? ('Success' | translate) : ('Partial Success' | translate) }}
            </h6>
            <p class="mb-0">
              {{ 'Successfully published' | translate }}: {{ publishResult.successfulOverwrites }} / {{ publishResult.totalPathsProcessed }}
            </p>
            <div *ngIf="publishResult.overwrittenPaths && publishResult.overwrittenPaths.length > 0" class="mt-2">
              <small>
                <strong>{{ 'Backup paths created' | translate }}:</strong>
                <ul class="mb-0 mt-1">
                  <li *ngFor="let overwritten of publishResult.overwrittenPaths">
                    <code>{{ overwritten.backupPath }}</code>
                  </li>
                </ul>
              </small>
            </div>
            <p *ngIf="publishResult.errorMessage" class="text-danger mt-2 mb-0">
              {{ publishResult.errorMessage }}
            </p>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()" [disabled]="isPublishing">
          {{ 'Close' | translate }}
        </button>
        <button type="button"
                class="btn btn-primary"
                (click)="executeMicroPublish()"
                [disabled]="isPublishing || isLoading || selectedPaths.size === 0">
          <span *ngIf="isPublishing" class="spinner-border spinner-border-sm mr-1" role="status"></span>
          {{ isPublishing ? ('Publishing' | translate) : ('Publish Selected' | translate) }}
        </button>
      </div>
    </div>
  </div>
</div>
